import React, { useState } from "react";
import Modal from "../../../components/Modals/Modal";  // Updated import path

interface Company {
  id: number;
  user: string;
  service: string;
  category: string;
  fechasolicitud: Date;
  fechaservicio: Date;
  empresa: string;
  precio: number;
  accionfinalizar: string;
}

const TableRequestResume: React.FC = () => {
  const [companies, setCompanies] = useState<Company[]>([
    { id: 2356, user: "Juan Camilo", service: "Guardería de mascotas", category: "Mascotas", fechasolicitud: new Date("2024-06-25"), fechaservicio: new Date("2024-06-27"), empresa: "Pet Feliz", precio: 250000, accionfinalizar: "Activa" },
    { id: 2564, user: "Esteban", service: "Lavado de carro", category: "Automotriz", fechasolicitud: new Date("2024-06-22"), fechaservicio: new Date("2024-06-25"), empresa: "car poblado", precio: 25000, accionfinalizar: "Finalizada"},
    { id: 2444, user: "Diego Alejandro", service: "Corte de cabello", category: "Belleza", fechasolicitud: new Date("2024-05-12"), fechaservicio: new Date("2024-05-15"), empresa: "belleza y algo mas", precio: 120000, accionfinalizar: "Finalizada"},
    { id: 2699, user: "Estefanía Garzes", service: "Cita médica", category: "Salud", fechasolicitud: new Date("2024-06-30"), fechaservicio: new Date("2024-07-2"), empresa: "clinica soma", precio: 86000, accionfinalizar: "Cancelada"},
    { id: 2554, user: "Carlos Perez", service: "Guardería de mascotas", category: "Mascotas", fechasolicitud: new Date("2024-05-7"), fechaservicio: new Date("2024-05-28"), empresa: "Mi mascota feliz", precio: 86000, accionfinalizar: "Finalizada"},
    { id: 2357, user: "Carlos Perez", service: "Claces de guitarra", category: "Musica", fechasolicitud: new Date("2024-07-11"), fechaservicio: new Date("2024-07-14"), empresa: "los parranderos", precio: 60000, accionfinalizar: "Finalizada"},
    { id: 2657, user: "Carlos Perez", service: "Fabricación de mueble", category: "Carpinteria", fechasolicitud: new Date("2024-05-20"), fechaservicio: new Date("2024-05-25"), empresa: "muebles y algo mas", precio: 1200000, accionfinalizar: "Activa"},
    { id: 6357, user: "Carlos Perez", service: "Peluqueria Mascotas", category: "Mascotas", fechasolicitud: new Date("2024-05-10"), fechaservicio: new Date("2024-05-27"), empresa: "Pet cambriedge", precio: 160000, accionfinalizar: "Activa"},
    { id: 7357, user: "Carlos Perez", service: "Corte de cabello", category: "Belleza", fechasolicitud: new Date("2024-06-24"), fechaservicio: new Date("2024-06-28"), empresa: "Alisados duran", precio: 120000, accionfinalizar: "Activa"},
    { id: 2577, user: "Carlos Perez", service: "Cita médica", category: "Salud", fechasolicitud: new Date("2024-02-15"), fechaservicio: new Date("2024-02-12"), empresa: "Laboratoria gen", precio: 700000, accionfinalizar: "Finalizada"},
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<Company | null>(null);

  const handleOpenModal = (company: Company) => {
    setSelectedCompany(company);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCompany(null);
  };

  const sortCompanies = (criteria: string) => {   
    const sortedCompanies = [...companies];

    switch (criteria) {
      case "fechasolicitud":
        sortedCompanies.sort((a, b) => a.fechasolicitud.getTime() - b.fechasolicitud.getTime());
        break;        
      case "precio":
        sortedCompanies.sort((a, b) => b.precio - a.precio);
        break;
      default:
        break;
    }

    setCompanies(sortedCompanies);    
  }; 

  return (
    <div className=""> 
      <Modal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title="Detalles del Servicio"
      >
        {selectedCompany && (
          <div className="text-center">
            <div className="space-y-4 text-left">
              <div className="grid grid-cols-2 gap-2 text-xs">
                <p><span className="font-bold">ID:</span> {selectedCompany.id}</p>
                <p><span className="font-bold">Usuario:</span> {selectedCompany.user}</p>
                <p><span className="font-bold">Servicio:</span> {selectedCompany.service}</p>
                <p><span className="font-bold">Categoría:</span> {selectedCompany.category}</p>
                <p><span className="font-bold">Empresa:</span> {selectedCompany.empresa}</p>
                <p><span className="font-bold">Precio:</span> ${selectedCompany.precio}</p>
                <p><span className="font-bold">Estado:</span> {selectedCompany.accionfinalizar}</p>
              </div>
            </div>
            <button
              className="w-36 mt-6 bg-[#F97068] hover:bg-red-500 text-white px-4 py-1 rounded-lg text-sm"
              onClick={handleCloseModal}
            >
              Cerrar
            </button>
          </div>
        )}
      </Modal>
      <h1 className="text-lg font-bold text-center">Resumen Solicitudes y Servicios</h1>
      <div className="flex items-center gap-4 mb-4">
        <label htmlFor="sort" className="text-sm font-medium">
          Ordenar por:
        </label>
        <select
          id="sort"
          className="border rounded p-2 text-sm"
          onChange={(e) => sortCompanies(e.target.value)}
        >
          <option value="">Selecciona un criterio</option>
          <option value="fechasolicitud">fecha solicitud</option>         
          <option value="precio">precio</option>  
        </select>
      </div>
      <div className="overflow-y-auto max-h-96 border rounded-md">
        <table className="table-auto w-full border-collapse border border-gray-200 max-h-96">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-2 py-3 text-xs text-left">ID</th>
              <th className="px-2 py-3 text-xs text-center">Usuario</th>
              <th className="px-2 py-3 text-xs text-center">Servicio</th>
              <th className="px-2 py-3 text-xs text-center">Categoría</th>
              <th className="px-2 py-3 text-xs text-center">Fecha Solicitud</th>
              <th className="px-2 py-3 text-xs text-center">Fecha Servicio</th>
              <th className="px-8 py-3 text-xs text-center">Empresas</th>
              <th className="px-2 py-3 text-xs text-center">Precio</th>             
              <th className="px-2 py-3 text-xs text-center">Estado</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((company) => (
              <tr key={company.id} className="border-t hover:bg-gray-50 cursor-pointer" onClick={() => handleOpenModal(company)}>
                <td className="px-2 py-4 text-xs text-left text-gray-700 ">{company.id}</td>
                <td className="px-2 py-4 text-xs text-center text-gray-700 ">{company.user}</td>
                <td className="px-2 py-4 text-xs text-center text-gray-700">{company.service}</td>
                <td className="px-2 py-4 text-xs text-center text-gray-700">{company.category}</td>
                <td className="px-2 py-4 text-xs text-center text-gray-700">{company.fechasolicitud.toLocaleDateString("es-CO")}</td>
                <td className="px-2 py-4 text-xs text-center text-gray-700">{company.fechaservicio.toLocaleDateString("es-CO")}</td>
                <td className="px8- py-4 text-xs text-center text-gray-700">{company.empresa}</td>
                <td className="px-2 py-4 text-xs text-center text-gray-700">{company.precio}</td>   
                <td className="px-2 py-4 text-xs text-center text-gray-700">{company.accionfinalizar}</td>              
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableRequestResume;

